import $ from 'jquery';
import _ from 'underscore';
import UI from 'root/ui';
import Cache from 'root/cache';
import Constants from 'root/constants';
import View from 'view/base';

export default View.extend({
    feedback_ids: [],

    project_id: 0,
    workflow_id: 0,
    user_id: undefined,

    workflow_options: {},

    events: {
        'click .dropdown-project .dropdown-select li' : 'onSelectProject',
        'click .dropdown-assignee .dropdown-select li': 'onSelectAssignee',
        'click .dropdown-workflow .dropdown-select li': 'onSelectWorkflow',
        'click .submit'                               : 'onSubmit',
    },

    dom_handlers: {
        onSelectProject: function(e) {
            var project_id = $(e.currentTarget).data('id');

            // reset data when project is changed
            this.project_id = project_id;
            this.workflow_id = 0;
            this.user_id = undefined;

            this.$el.find('.dropdown-workflow button').html('<span class="placeholder-text">Select...</span>');
            this.$el.find('.dropdown-workflow ul').html('');
            this.$el.find('.dropdown-assignee button').html('<span class="placeholder-text">Select...</span>');
            this.$el.find('.dropdown-assignee ul').html('');

            this.renderWorkflows();
            this.renderAssignees();

            this.checkFormData();
        },

        onSelectWorkflow: function(e) {
            this.workflow_id = $(e.currentTarget).data('workflow');

            this.checkFormData();
        },

        onSelectAssignee: function(e) {
            this.user_id = $(e.currentTarget).data('id');

            this.checkFormData();
        },

        onSubmit: function(e) {
            var include_merged_feedback = this.$el.find('.include-merged-feedback').prop('checked');

            $(e.currentTarget).addClass('loading').prop('disabled', true);

            Cache.app.request({
                action: 'feedback/move',
                data: {
                    feedback_ids           : this.feedback_ids,
                    project_id             : this.project_id,
                    workflow_id            : this.workflow_id,
                    user_id                : this.user_id,
                    include_merged_feedback: include_merged_feedback
                },
                success: () => {
                    var project = Cache.project.get(this.project_id);
                    var project_name= project.get('name');

                    var merged_feedback_ids = this.feedback_ids.flatMap((id) => {
                        const model = Cache.feedback.get(id);

                        return model ? model.getMergedFeedbackIds() : [];
                    });

                    if (include_merged_feedback) {
                        Cache.feedback.remove(merged_feedback_ids);
                    } else {
                        merged_feedback_ids.forEach((feedback_id) => {
                            var model = Cache.feedback.get(feedback_id);

                            // when 'include merged' filter is not selected, can not get merged feedback model
                            if (model) {
                                model.set({
                                    primary_feedback_id: 0,
                                    update  : model.get('update') ? false: true,
                                });
                            }
                        });
                    }

                    Cache.feedback.remove(this.feedback_ids);

                    UI.success(`Feedback moved to project “${project_name}”`);

                    this.trigger('submit:success');
                }
            });
        },
    },

    getWorkflowOptions: function() {
        Cache.app.request({
            action: 'workflow/getData',
            data:{
                is_active: true,
                all_projects: true
            },
            success: (res) => {
                if (!res) {
                    return;
                }

                var workflow_options = _.groupBy(res, (item) => item.project_id);

                this.workflow_options = workflow_options;
            }
        });
      },

    checkFormData: function() {
        var complete = this.project_id && this.workflow_id && this.user_id !== undefined;

        this.$el.find('.submit').prop('disabled', !complete);
    },

    renderWorkflows: function() {
        var workflow_options = this.workflow_options[this.project_id] || [];
        var workflows = '';

        workflow_options.forEach((option, index) => {
            workflows +=
            '<li data-workflow="' + option.id + '">' +
                '<span class="workflow-option-colour" style="background-color:' + option.colour + ';"></span>' +
                option.name +
            '</li>';
        });

        this.$el.find('.dropdown-workflow ul').html(workflows);
      },

    renderAssignees: function() {
        var users = '';
        var project_user_models = Cache.app.getUsersByProject(this.project_id, [Constants.ADMIN, Constants.ASSIGNEE]);
        _.each(project_user_models, (user) => {
            users +=
                '<li data-id="' + user.id + '">' +
                    '<div class="flex-start">' +
                        '<img class="user-24 user-solid" src="' + user.getAvatar(24) + '">' +
                        '<span class="margin-left-4">' + user.escape('name') + '</span>' +
                    '</div>' +
                '</li>';
        });

        users +=
        '<li class="separator"></li>' +
        '<li data-id="0">' +
            '<div class="flex-start">' +
                '<div class="user-24">?</div>' +
                '<div class="margin-left-4">Unassigned</div>' +
            '</div>' +
        '</li>';

        this.$el.find('.dropdown-assignee ul').html(users);
    },

    initialize: function(options) {
        this.feedback_ids = options.feedback_ids;

        this.getWorkflowOptions();
    },

    render: function() {
        var projects = '';

        Cache.project.each((option) => {
            if (option.isFeedback() && option.id !== Cache.default_project_id && option.get('is_archived') === false) {
                projects +=
                '<li class="dropdown-action" data-id="' + option.id + '">' + option.escape('name') + '</li>';
            }
        });

        var id = _.uniqueId();

        var include_primary_feedback = this.feedback_ids.some((id) => {
            const model = Cache.feedback.get(id);
            return model ? model.isPrimaryFeedback() : false;
        });

        var content =
            '<div class="text-info margin-bottom-16"><i class="fa-solid fa-circle-exclamation text-icon"></i> Once moved, the current URLs for the feedback, screenshots and attachments will no longer be available.</div>' +
            '<form class="form-fluid">' +
                '<div class="row">' +
                    '<div class="field-label">Select a project</div>' +
                    '<div class="button-dropdown button-dropdown-full dropdown-project" data-update="true">' +
                        '<button type="button" class="dropdown-select dropdown-select-medium"><span class="placeholder-text">Select...</span></button>' +
                        '<div>' +
                            '<div class="dropdown-search">' +
                                '<input type="text" class="solid compact" placeholder="Search">' +
                            '</div>' +
                            '<ul class="dropdown dropdown-select">' + projects + '</ul>' +
                        '</div>' +
                    '</div>' +
                '</div>' +
                '<div class="row">' +
                    '<div class="field-label">Status</div>' +
                    '<div class="button-dropdown button-dropdown-full dropdown-workflow" data-update="true">' +
                        '<button type="button" class="dropdown-select dropdown-select-medium"><span class="placeholder-text">Select...</span></button>' +
                        '<div>' +
                            '<div class="dropdown-search">' +
                                '<input type="text" class="solid compact" placeholder="Search">' +
                            '</div>' +
                            '<ul class="dropdown dropdown-select"></ul>' +
                        '</div>' +
                    '</div>' +
                '</div>' +
                '<div class="row">' +
                    '<div class="field-label">Assignee</div>' +
                    '<div class="button-dropdown button-dropdown-full dropdown-assignee" data-update="true">' +
                        '<button type="button" class="dropdown-select dropdown-select-medium"><span class="placeholder-text">Select...</span></button>' +
                        '<div>' +
                            '<div class="dropdown-search">' +
                                '<input type="text" class="solid compact" placeholder="Search">' +
                            '</div>' +
                            '<ul class="dropdown dropdown-select"></ul>' +
                        '</div>' +
                    '</div>' +
                '</div>' +
            '</form>' +
            '<div class="' + (include_primary_feedback ? 'flex-between' : '') + ' padding-top-30">' +
                (include_primary_feedback ?
                '<div>' +
                    '<input type="checkbox" class="include-merged-feedback" id="' + id + '"><label for="' + id + '">Also move all merged feedback</label>' +
                '</div>' : '') +
                '<div class="' + (include_primary_feedback ? '' : 'flex-end') + '"><button type="button" class="submit primary" disabled>Move</button></div>' +
            '</div>';

        this.$el.html(content);

        return this;
    }
});